import { Selectable } from "./abstractions/Selectable";

export class IntermediaryNumber extends Selectable {
    id: number;
    code: string;
    name: string;

    constructor(id: number, code: string, name: string) {
        super(name, code);
        this.id = id;
        this.code = code;
        this.name = name;
    }
}
